module.exports = __webpack_public_path__ + "img/logo.96707a61.svg";